import BackButton from "@/app/shared/support/inbox/back-button";
import MessageDetails from "@/app/shared/support/inbox/message-details";
import MessageList from "@/app/shared/support/inbox/message-list";

export default function Page() {
    return (
        <>
            <div className="mt-5 items-start @container lg:mt-9 lg:grid lg:grid-cols-[330px_1fr] lg:gap-7 2xl:grid-cols-[400px_1fr]">
                <div className="col-span-full">
                    <BackButton />
                </div>

                <MessageList className="lg:hidden" />
                <MessageDetails />
            </div>
        </>
    );
}
